// extracted by mini-css-extract-plugin
module.exports = {"dialog":"RouterPrompt_dialog__3VFUo","dialog__content":"RouterPrompt_dialog__content__3VAPG","dialog__navigation":"RouterPrompt_dialog__navigation__2VYKJ"};